import BaseService from "./BaseService";
import http from "./HttpService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/booking-request";

export default class BookingRequestsService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	toggleStatus(id, params) {
		return http.put(`${apiEndpoint}/${id}/status`, { ...params });
	}

	sendEmail(id) {
		return http.post(`${apiEndpoint}/${id}/send-email`);
	}
}
